import { z } from 'zod';
import { isMongoId } from '../../helpers';
import CalendarDay from '../../../utils/calendar-day';

// Income & Expenses (group-based)
export const CanReverseIncomeOrExpenseSchema = z.object({
  groupId: z.string().refine(isMongoId(), {
    message: 'Invalid group ID',
  }),
});

export const GetIncomeOrExpenseReversalTransactionsSchema = z.object({
  groupId: z.string().refine(isMongoId(), {
    message: 'Invalid group ID',
  }),
  reversalDate: z.instanceof(CalendarDay),
});

export const ReverseIncomeOrExpenseSchema = z.object({
  groupId: z.string().refine(isMongoId(), {
    message: 'Invalid group ID',
  }),
  reversalDate: z.instanceof(CalendarDay),
});

// Generic (action-based, for investments/realisations)
export const CanReverseSchema = z.object({
  actionId: z.string().refine(isMongoId(), {
    message: 'Invalid action ID',
  }),
});

export const GetReversalTransactionsSchema = z.object({
  actionId: z.string().refine(isMongoId(), {
    message: 'Invalid action ID',
  }),
  reversalDate: z.instanceof(CalendarDay),
});

export const ReverseActionSchema = z.object({
  actionId: z.string().refine(isMongoId(), {
    message: 'Invalid action ID',
  }),
  reversalDate: z.instanceof(CalendarDay),
});

export const GetReversalSchema = z.object({
  actionId: z.string().refine(isMongoId(), {
    message: 'Invalid action ID',
  }),
});

export const DeleteReversalSchema = z.object({
  reversalId: z.string().refine(isMongoId(), {
    message: 'Invalid reversal ID',
  }),
});
